export function Stat({ icon: Icon, label, value, sub, tone = "violet", testid }) {
  const tones = {
    violet: "bg-[#EDE9FE] text-[#5B21B6]",
    green: "bg-[#ECFDF5] text-[#059669]",
    amber: "bg-[#FFFBEB] text-[#D97706]",
    rose: "bg-[#FFF1F2] text-[#E11D48]",
    blue: "bg-[#EFF6FF] text-[#2563EB]",
  };
  return (
    <div className="ember-card p-5" data-testid={testid}>
      <div className="flex items-center justify-between">
        <span className="text-sm font-semibold text-[#524B6B]">{label}</span>
        {Icon && <span className={`grid h-9 w-9 place-items-center rounded-lg ${tones[tone]}`}><Icon className="h-[18px] w-[18px]" /></span>}
      </div>
      <div className="mt-3 font-heading text-3xl font-extrabold text-[#1E1B2E]">{value}</div>
      {sub && <div className="mt-1 text-xs font-medium text-[#948EAB]">{sub}</div>}
    </div>
  );
}

export function ScoreRing({ pct = 0, size = 132 }) {
  const r = (size - 16) / 2;
  const c = 2 * Math.PI * r;
  const color = pct >= 80 ? "#059669" : pct >= 60 ? "#7C3AED" : "#E11D48";
  return (
    <div className="relative" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="#EDE9FE" strokeWidth="12" fill="none" />
        <circle cx={size / 2} cy={size / 2} r={r} stroke={color} strokeWidth="12" fill="none"
          strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c - (c * pct) / 100}
          style={{ transition: "stroke-dashoffset 1s cubic-bezier(.22,1,.36,1)" }} />
      </svg>
      <div className="absolute inset-0 grid place-items-center">
        <div className="text-center">
          <div className="font-heading text-3xl font-extrabold text-[#1E1B2E]">{Math.round(pct)}%</div>
        </div>
      </div>
    </div>
  );
}

export function AccuracyBar({ pct }) {
  const color = pct >= 80 ? "#059669" : pct >= 65 ? "#7C3AED" : "#E11D48";
  return (
    <div className="h-2.5 w-full overflow-hidden rounded-full bg-[#EDE9FE]">
      <div className="h-full rounded-full" style={{ width: `${pct}%`, backgroundColor: color, transition: "width .8s ease" }} />
    </div>
  );
}

export function PageHeader({ title, subtitle, right }) {
  return (
    <div className="mb-7 flex flex-wrap items-end justify-between gap-4">
      <div>
        <h1 className="font-heading text-3xl font-extrabold tracking-tight text-[#1E1B2E] sm:text-4xl">{title}</h1>
        {subtitle && <p className="mt-1.5 text-[#524B6B]">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

export function Loading() {
  return (
    <div className="grid place-items-center py-24">
      <div className="h-10 w-10 animate-spin rounded-full border-[3px] border-[#EDE9FE] border-t-[#7C3AED]" />
    </div>
  );
}

export function fmtTime(sec = 0) {
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}
